"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var PropertyCreationDialogModule = /** @class */ (function () {
    function PropertyCreationDialogModule() {
    }
    return PropertyCreationDialogModule;
}());
exports.PropertyCreationDialogModule = PropertyCreationDialogModule;
